import { WV_BLUE, WV_GOLD, FONT_BODY } from '../theme';
/**
 * Portal theme for the hosted widget, mirroring `appTheme` so the panel matches
 * the site rather than the package's built-in `westVirginiaTheme` (which uses a
 * different navy/gold pair and a Gotham font stack).
 *
 * The widget runs a WCAG 2.2 AA contrast audit on this object at mount and
 * **throws** on any failing pair, so two values deliberately differ from `appTheme`:
 * - `onSecondary` is WV blue, not `secondary.contrastText` — white on
 *   `#CC9F38` is only 2.45:1, while blue on gold is 6.52:1.
 * - `border` is an opaque `#8a8f99` (3.25:1) rather than MUI's translucent
 *   default `divider`.
 */
export const portalAccessibilityTheme = {
    /**
     * `id` also namespaces persisted settings in `localStorage`
     * (`delasoft.a11y.settings.<id>`) — deliberately distinct from the package's
     * built-in `westVirginiaTheme.id` ('west-virginia') so this portal never
     * inherits font-scale / color-mode / spacing choices saved during testing of
     * an earlier, differently-themed mount of the same widget on this origin.
     */
    id: 'wv-onestop-portal',
    name: 'State of West Virginia',
    mode: 'light',
    palette: {
        primary: WV_BLUE,
        secondary: WV_GOLD,
        /** `appTheme.palette.background.paper` */
        surface: '#ffffff',
        /** `appTheme.palette.background.default` */
        surfaceRaised: '#f0f4f8',
        /** `appTheme.palette.text.primary` */
        text: WV_BLUE,
        /** `appTheme.palette.text.secondary` */
        textMuted: '#4a5568',
        onPrimary: '#ffffff',
        onSecondary: WV_BLUE,
        border: '#8a8f99',
    },
    typography: {
        fontFamily: FONT_BODY,
        /** Matches `body1` (1rem) so panel text tracks the rest of the portal. */
        baseSize: 16,
    },
    shape: { radius: 10, triggerRadius: 28 },
    /** Bottom-right is the WV Permit AI chat embed's corner (see `public/index.html`). */
    triggerPosition: 'bottom-left',
    labelTone: 'plain',
    secondaryOnPrimaryOnly: true,
};
